<template>
  <div class="handpick-package">
    <header>
      <h3>精选体检</h3>
      <span @click="goToPage"
        >更多套餐<svg-icon name="icon_arrow_rig_gray"></svg-icon
      ></span>
    </header>
    <span class="subhead">袋鼠推荐热门体检套餐</span>
    <NavBar />
  </div>
</template>

<script>
import NavBar from "@/components/common/NavBar";
export default {
  name: "HandpickPackage",
  components: {
    NavBar,
  },
  methods: {
    goToPage() {
      this.$baiDuMtaEvent(["个检/首页", `点击更多套餐`, "", "-"]);
      this.$router.push({
        path: "package-org-list",
        query: { type: "package" },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.handpick-package {
  padding: 0 24/200rem;
  margin-top: 48/200rem;
  font-family: PingFangSC-Regular, PingFang SC;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 6/200rem;
    h3 {
      font-size: 32/200rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 44/200rem;
    }
    span {
      font-size: 24/200rem;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #85898c;
      line-height: 24/200rem;
    }
    svg-icon {
      width: 24/200rem;
      height: 24/200rem;
      margin-left: 4/200rem;
    }
  }
  .subhead {
    margin: 8/200rem 0 32/200rem 6/200rem;
    font-size: 22/200rem;
    color: #85898c;
    line-height: 22/200rem;
  }
}
</style>
